var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2712 13.0989C17.2602 11.0679 18.1712 9.53499 20.0152 8.40607C18.9835 6.91744 17.4248 6.09841 15.3668 5.93793C13.4185 5.78298 11.2891 7.08345 10.5098 7.08345C9.68656 7.08345 7.79864 5.99327 6.31684 5.99327C3.25446 6.04307 0 8.45587 0 13.3645C0 14.8144 0.26343 16.3122 0.790291 17.8581C1.49277 19.889 4.02829 24.8696 6.67357 24.7866C8.05658 24.7534 9.03347 23.796 10.8336 23.796C12.5788 23.796 13.4843 24.7866 15.0265 24.7866C17.6937 24.7478 19.9878 20.221 20.6573 18.1846C17.0791 16.4856 17.2712 13.204 17.2712 13.0989ZM14.1649 4.01211C15.6631 2.21911 15.5259 0.586599 15.482 0C14.1594 0.0774753 12.6282 0.907568 11.7556 1.93135C10.7952 3.02707 10.2299 4.38289 10.3506 5.91026C11.783 6.02094 13.0892 5.27939 14.1649 4.01211Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.386f54ab070adbf6390a212c6ad59f9c.svg";
export { ForwardRef as ReactComponent };